import ReactDOM from "react-dom/client";
import * as Konva from "react-konva";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { DraggableItem } from "./draggable-item.class";
import { Layer, FirestoreLayerObj } from "./layer.class";
// T1.7 · onde o item esta na pilha da pagina. A conta mora num modulo puro; este arquivo so
// repassa as proprias paginas, que sao privadas.
import { ondeNaPilha } from "./onde-na-pilha";
import { Stage } from "konva/lib/Stage";
import { Group } from "konva/lib/Group";
import ConfirmPopUp, { PopUpInfo } from "../components/confirm-pop-up";
import Firebase from "../api/firebase.class";
import Utils from "./utils.class";
import { DraggableItemFactory } from "./draggable-item-factory.class";
import { ImgInfo } from "../api/app-user.class";
import { Reticula } from "../api/documento.types";
import { Rectangle } from "./rectangle.class";
import jsPDF from "jspdf";
import { TouchableItem } from "./touchable-item";
import styled from "@emotion/styled";

export type ComicObj = {
  name: string;
  pages: { [page: number]: FirestoreLayerObj };
};
export type ComicArr = FirestoreLayerObj[];
export type ComicObjs = { [id: string]: ComicObj };
export type ElType =
  | "scenarios"
  | "characters"
  | "textBubbles"
  | "rectangles"
  | "figures";

type ComicConstructorObj = {
  pages: Layer[];
  id?: string;
  name?: string;
};
export type FirestoreComicObj = {
  pages: Record<number, FirestoreLayerObj>;
  name: string;
};

export const ItemMenuContainer = styled.div`
  /* ══ O BOTAO QUE ENVOLVE O ICONE — 26/09 ══════════════════════════════════════════════════
   *
   * Os onze controles deste menu eram imagem com onClick: 44x44 medidos, e nenhum deles
   * alcancavel por teclado. Viraram botao de verdade (ver "BotaoDoMenu" em
   * draggable-menu-btns.tsx), e o botao nao pode acrescentar nada ao tamanho — o menu media
   * 332x56 e continua medindo.
   *
   * "line-height: 0" porque a imagem e inline por padrao e a linha de texto deixaria alguns
   * pixels fantasmas embaixo de cada icone, empurrando o menu.
   *
   * E O ANEL DE FOCO E O PONTO DE TODA A MUDANCA: sem ele, o botao e alcancavel por Tab e
   * invisivel — que e meio caminho e engana mais que a imagem, porque o foco esta em algum lugar
   * e ninguem ve onde.
   *
   * (Sem acento grave neste comentario: ele vive dentro de um template literal do
   * styled-components, e um acento grave aqui FECHA a string. Custou um tsc vermelho.) */
  .item-menu-btn {
    padding: 0;
    margin: 0;
    border: 0;
    background: none;
    line-height: 0;
    border-radius: 8px;
    cursor: pointer;
  }

  .item-menu-btn:focus-visible {
    outline: 3px solid #1b1b1b;
    outline-offset: 2px;
  }

  /* O estado de um botao que liga e desliga (negrito, sublinhado, italico) ja aparece no icone
   * preenchido; o aria-pressed diz o mesmo para quem ouve, e este anel o diz para quem ve. */
  .item-menu-btn[aria-pressed="true"] {
    outline: 2px solid #1b1b1b;
    outline-offset: 1px;
  }

  position: fixed;
  /* T24 · ERA 100, O MESMO NÚMERO DAS JANELAS (modal.scss) E DOS AVISOS: com um item selecionado, a
     barra dele ("camada 2/6") pintava POR CIMA da janela de gerar personagem — o print do operador
     em 13/10. 40 fica acima da folha e abaixo de qualquer janela ou aviso. */
  z-index: 40;
  display: flex;
  align-items: center;
  background-color: navajowhite;
  /* O menu flutua sobre a folha: sem borda ele se confunde com o desenho embaixo. */
  border: 2px solid #1b1b1b;
  border-radius: 10px;
  padding: 4px;
  gap: 2px;

  /*
   * ══ 44px, E NÃO 20 ═══════════════════════════════════════════════════════════════════════
   *
   * T4.7. Estes botões — apagar, duplicar, espelhar, as duas camadas, as cores — tinham 20x20px
   * num produto cuja régua é 44, e foram os ÚNICOS controles que sobraram fora dela depois da
   * varredura de 13/09. Não é detalhe: é o menu onde mora o controle de camadas que ele disse
   * QUATRO VEZES que não existia.
   *
   * O ícone continua sendo desenhado a 24px — o "padding" com "border-box" faz a caixa crescer
   * sem esticar a figura, que é raster e borraria.
   *
   * A posição do menu acompanha sozinha: "getItemMenuPos" mede o próprio menu. O que ela NÃO
   * fazia era prender o resultado na janela, e com 44px isso passou a aparecer — está consertado
   * lá, com o porquê escrito.
   */
  > img,
  > svg,
  > select {
    box-sizing: border-box;
    cursor: pointer;
    /*
     * "flex: none" E O QUE FAZ OS 44 SEREM 44. Medido: sem ele os seis botoes saiam com 40px —
     * o flex os encolhia para o conjunto caber, e um alvo de toque que encolhe conforme quantos
     * irmaos tem nao e um alvo de toque, e uma media.
     */
    flex: none;
    width: 44px;
    height: 44px;
    padding: 10px;
    border-radius: 8px;
  }

  > img:hover,
  > svg:hover,
  > select:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export class Comic extends TouchableItem {
  private id: string;
  private name: string;
  private pages: Layer[];
  private selectedItem: DraggableItem | null;

  /**
   * O GANCHO DO DESFAZER (C3 da especificacao 002).
   *
   * Toda alteracao do quadrinho passa por um metodo desta classe — `addItem`, `deleteItem`,
   * `moveEl`, `clearPage`, `addPage`, `deletePage` — ou pelos dois manipuladores de arraste e
   * transformacao, que sao definidos UMA vez no `renderPage` e descem para todo tipo de item.
   * Por isso o registro mora aqui, e nao espalhado por cada tela: sao sete chamadas num arquivo
   * so, e nenhuma alteracao escapa por uma porta que ninguem lembrou de instrumentar.
   *
   * O retrato e tirado ANTES de mexer, e e uma copia PROFUNDA (`copy()` clona pagina por pagina
   * e item por item). Guardar a referencia viva devolveria o estado ja alterado.
   */
  private registrarAntes: ((anterior: Comic) => void) | undefined;

  aoAlterar(cb: ((anterior: Comic) => void) | undefined) {
    this.registrarAntes = cb;
  }

  /**
   * ALTERADO DESDE O ULTIMO `save`? — T2.44 do pedido.
   *
   * "quando aperta voltar, EU PERCO TUDO."
   *
   * O TS-T2.6.2 resolveu metade: com `/dashboard` quebrado em rotas, voltar do editor cai no
   * acervo em vez de sair da area inteira. A metade que faltava era AVISAR — e para avisar e
   * preciso SABER que ha alteracao pendente.
   *
   * E nao dava. `isSaved()` e `return !!this.id`: ele responde "tem id", nao "esta em dia". Um
   * quadrinho salvo ontem e editado agora responde `true`.
   *
   * ── POR QUE ESTE CONTADOR E NAO UMA COMPARACAO DE RETRATO ─────────────────────────────────
   *
   * O caminho obvio seria guardar o `toObj()` do ultimo save e comparar. Mas `toObj()` percorre
   * paginas, camadas e itens, e comparar dois JSON de um quadrinho com imagens em base64 e
   * megabytes de trabalho a cada checagem — num navegador de celular de escola.
   *
   * O `registrar()` ja acontece em TODA alteracao: ele existe para alimentar o desfazer, e por
   * isso passa em arrastar, redimensionar, inserir, apagar e trocar de ordem. Contar as chamadas
   * dele e barato e responde a pergunta certa: houve alteracao depois do ultimo save?
   *
   * O CUSTO HONESTO: e uma aproximacao POR CIMA. Desfazer tres vezes e voltar ao estado original
   * conta como tres alteracoes, e o aviso aparece embora nada tenha mudado de fato. Preferi
   * errar para o lado de avisar demais: um aviso a mais e um clique, um aviso a menos e o
   * trabalho da crianca.
   */
  private alteracoesDesdeOSave = 0;

  private registrar() {
    this.alteracoesDesdeOSave++;
    this.registrarAntes?.(this.copy());
  }

  /** Ha alteracao que ainda nao foi salva? Ver o comentario de `registrar()` para o limite. */
  temAlteracaoNaoSalva() {
    return this.alteracoesDesdeOSave > 0;
  }

  private setItems:
    | React.Dispatch<React.SetStateAction<DraggableItem[]>>
    | undefined;
  private setSelectedItem:
    | React.Dispatch<React.SetStateAction<DraggableItem | null>>
    | undefined;

  static fromFirestoreComicObj(
    id: string,
    comicObj: FirestoreComicObj,
    imgs: Record<string, ImgInfo>
  ): Comic {
    const pages = Object.values(comicObj.pages).map((page) =>
      Layer.fromFirestoreLayerObj(page, imgs)
    );
    return new Comic({ id, name: comicObj.name, pages });
  }

  /**
   * Um quadrinho novo, com o tamanho de página que a pessoa escolheu.
   *
   * O PADRÃO ERA `window.innerWidth * 0.75` POR `window.innerHeight * 0.8`, e isso não é um
   * padrão: é um acidente. O tamanho da página passava a depender do tamanho da TELA de quem
   * criou — um quadrinho feito no celular nascia minúsculo, um feito num monitor largo nascia
   * gigante, e nenhum dos dois é formato de quadrinho. Reaberto noutra tela, o quadrinho mantinha
   * a medida estranha da tela original para sempre.
   *
   * É a raiz do T1.13 do pedido ("novo quadrinho sem escolher tamanho"): não era só que a tela
   * não perguntava — é que a resposta que ela dava sozinha não fazia sentido.
   *
   * O padrão agora é a tirinha, que é o formato mais curto e o que uma criança termina numa aula.
   */
  static getEmptyComic(largura = 1200, altura = 400) {
    return new Comic({
      pages: [new Layer(largura, altura)],
    });
  }

  constructor(
    comicObj: ComicConstructorObj,
    selectedItem: DraggableItem | null = null
  ) {
    super();

    this.pages = comicObj.pages;
    this.id = comicObj.id || "";
    this.name = comicObj.name || "";

    this.selectedItem = selectedItem;
  }

  getId() {
    return this.id;
  }

  Pages(value?: Layer[]) {
    if (value !== undefined) {
      this.pages = value;
    }
    return this.pages;
  }
  SelectedItem(value?: DraggableItem | null) {
    if (value !== undefined) {
      this.selectedItem = value;
      if (!!this.setSelectedItem) {
        this.setSelectedItem(value);
      }
    }
    return this.selectedItem;
  }
  Name(value?: string) {
    if (value !== undefined) {
      this.name = value;
    }
    return this.name;
  }

  copy() {
    const c = new Comic(
      {
        pages: this.pages.map((page) => page.copy()),
        id: this.id,
        name: this.name,
      },
      this.selectedItem
    );
    // O CONTADOR VIAJA NA COPIA, e isto nao e detalhe: o editor trabalha sobre uma COPIA
    // (`acervo` -> `editar-quadrinho` -> `comic.copy()`), e `setComic(comic.copy())` acontece a
    // cada salvamento. Sem copiar o contador, toda copia nasceria "em dia" e o aviso do T2.44
    // nunca apareceria — um aviso que existe no codigo e nunca dispara e pior que nenhum.
    c.alteracoesDesdeOSave = this.alteracoesDesdeOSave;
    return c;
  }

  getPage(pageNum: number) {
    return this.pages[pageNum];
  }
  addPage(width: number, height: number) {
    this.registrar();
    return this.pages.push(new Layer(width, height));
  }
  deletePage(pageNum: number) {
    this.registrar();
    this.pages.splice(pageNum, 1);
  }

  clearPage(pageNum: number) {
    this.registrar();
    this.pages[pageNum].items = [];
  }
  isLastPage(pageNum: number) {
    return pageNum === this.pages.length - 1;
  }

  addItem(pageNum: number, item: DraggableItem) {
    this.registrar();
    this.pages[pageNum].items.push(item);
    if (!!this.setItems) {
      this.setItems([...this.pages[pageNum].items]);
    }
  }
  deleteItem(item: DraggableItem) {
    this.registrar();
    const pageNum = this.pages.findIndex(
      (page) => !!page.items.find((value) => value.id === item.id)
    );
    if (pageNum === -1) return;

    this.pages[pageNum].items = this.pages[pageNum].items.filter(
      (value) => value.id !== item.id
    );
    if (!!this.setItems) {
      this.setItems(this.pages[pageNum].items);
    }
    if (this.selectedItem?.id === item.id) {
      this.SelectedItem(null);
    }
  }
  async duplicateItem(
    item: DraggableItem,
    newValues?: { x?: number; y?: number; rotation?: number }
  ) {
    const pageNum = this.pages.findIndex(
      (page) => !!page.items.find((value) => value.id === item.id)
    );
    if (pageNum === -1) return;

    const newItem = DraggableItemFactory.clone(item);
    if (!!newValues) {
      newItem.x = newValues.x ?? newItem.x;
      newItem.y = newValues.y ?? newItem.y;
      newItem.rotation = newValues.rotation ?? newItem.rotation;
    }

    await newItem.waitImgLoad();
    this.pages[pageNum].items.push(newItem);
    if (!!this.setItems) {
      this.setItems([...this.pages[pageNum].items]);
    }
  }
  /**
   * REDESENHAR a página de um item cujo DADO mudou, e registrar para o desfazer.
   *
   * `setFillColor` e `setBorderColor` falam com o nó do Konva direto (`imageRef.setAttr`), e isso
   * funciona porque cor é um atributo que o Konva sabe trocar sozinho. A retícula não é: ela
   * precisa de uma `Image` nova, que carrega de forma assíncrona, e quem a monta é um `useEffect`
   * do React observando o dado.
   *
   * Então o caminho é o mesmo de `moveEl`: reemitir os itens, para o React redesenhar e o efeito
   * rodar. E `registrar()` junto, porque ligar retícula É uma alteração — sem ele, o aviso de
   * "você tem trabalho não salvo" não apareceria depois de mexer nela.
   */
  /**
   * A RETICULA EM TODAS AS PAGINAS — a metade do `T2.108` que faltava.
   *
   * A letra dele: *"tem que ter uma forma de aplicar reticula EM TODAS AS PAGINAS, se quiser, para
   * tentar criar uma UNIFORMIDADE dos desenhos, do traco"* — e e o unico dos 109 pontos em que ele
   * usa a palavra "essencial".
   *
   * O controle que existia era por item, no menu que aparece com a selecao. Uniformidade por item
   * exige tocar um por um: numa pagina A4 com seis quadros e duas paginas, sao doze gestos para
   * conseguir o que ele pediu em um.
   *
   * ── TRES DECISOES ────────────────────────────────────────────────────────────────────────────
   *
   * 1. **So quadro recebe trama.** Personagem, cenario, balao e figura sao desenho e texto; tramar
   *    por cima deles suja a arte em vez de unificar o traco. `Rectangle` e o quadro.
   * 2. **Uma alteracao no desfazer, e nao doze.** `registrar()` uma vez no comeco: desfazer tem que
   *    voltar o gesto que a pessoa fez, e ela fez um.
   * 3. **Devolve quantos mudaram.** A tela precisa dizer o que aconteceu ("tramei 12 quadros"), e
   *    sem o numero ela so pode dizer "pronto" — que e o que a pessoa ja estava vendo.
   */
  aplicarReticulaEmTudo(valor: Reticula, paginaAberta = 0) {
    this.registrar();
    let mudados = 0;
    let quadros = 0;
    for (const pagina of this.pages) {
      for (const item of pagina.items) {
        if (!(item instanceof Rectangle)) continue;
        quadros++;
        if ((item.reticula ?? "nenhuma") === valor) continue;
        item.setReticula(valor);
        mudados++;
      }
    }
    // Reemite os itens da pagina aberta para o Konva redesenhar o que esta na tela; as outras
    // paginas ja carregam o dado novo e desenham quando forem abertas.
    // Quem chama diz qual pagina esta na tela: o `Comic` guarda as paginas, nao o que a tela
    // mostra. Inventar um `paginaVisivel` aqui duplicaria estado que ja vive no componente.
    if (!!this.setItems && this.pages[paginaAberta]) {
      this.setItems([...this.pages[paginaAberta].items]);
    }
    return { mudados, quadros, paginas: this.pages.length };
  }

  redesenharItem(item: DraggableItem) {
    this.registrar();
    const pageNum = this.pages.findIndex(
      (page) => !!page.items.find((value) => value.id === item.id)
    );
    if (pageNum === -1) return;
    if (!!this.setItems) {
      this.setItems([...this.pages[pageNum].items]);
    }
  }

  isLowerItem(pageNum: number, item: DraggableItem) {
    return this.pages[pageNum].items[0].id === item.id;
  }
  isUpperItem(pageNum: number, item: DraggableItem) {
    return this.pages[pageNum].items.at(-1)?.id === item.id;
  }
  moveEl(item: DraggableItem, to: "up" | "down") {
    this.registrar();
    const pageNum = this.pages.findIndex(
      (page) => !!page.items.find((value) => value.id === item.id)
    );
    if (pageNum === -1) return;

    const index = this.pages[pageNum].items.findIndex(
      (value) => value.id === item.id
    );
    if (index === -1) return;

    const newIndex = to === "up" ? index + 1 : index - 1;
    if (newIndex < 0 || newIndex >= this.pages[pageNum].items.length) return;

    const [removedEl] = this.pages[pageNum].items.splice(index, 1);
    this.pages[pageNum].items.splice(newIndex, 0, removedEl);
    if (!!this.setItems) {
      this.setItems([...this.pages[pageNum].items]);
    }
  }

  /**
   * ONDE ESTE ITEM ESTA NA PILHA DA PAGINA — T1.7.
   *
   * `pages` e privado, e e por isso que este metodo existe em vez de a tela ler o array: quem
   * pergunta e o menu do item, e a conta mora num modulo puro que da para testar sem editor.
   */
  lugarNaPilha(item: DraggableItem) {
    return ondeNaPilha(this.pages, item);
  }

  renderPage(
    pageNum: number,
    options?: {
      width?: number;
      height?: number;
      viewOnly?: boolean;
      onClick?: () => void;
      /** Recebe o retrato ANTERIOR a cada alteracao. E o que alimenta o desfazer. */
      aoAlterar?: (anterior: Comic) => void;
      /**
       * O ZOOM DA FOLHA, aplicado no `scale` do proprio `Stage`.
       *
       * E deliberadamente OUTRO mecanismo que o `width`/`height` acima. Aqueles nao escalam o
       * palco: eles dimensionam a area visivel e repassam `scaleX`/`scaleY` a CADA item, que e o
       * caminho da miniatura (`viewOnly`). Editar por ali significaria arrastar item cujas
       * coordenadas de tela e de pagina divergem.
       *
       * O `scale` do `Stage` e o caminho em que o Konva converte a posicao do ponteiro de volta
       * para coordenadas de pagina sozinho — arrastar, selecionar e o transformador continuam
       * certos, e os itens seguem vivendo em coordenadas da folha.
       */
      zoom?: number;
      /**
       * A CAIXA DE DIÁLOGO DO EDITOR, E POR QUE ELA TEM DE VIR DE FORA — `T8.10`.
       *
       * O `PageEl` abaixo tem um `popUpInfo` próprio, e ele **não sobrevive a uma mudança de estado
       * do editor**: o comentário do `useState` da seleção já explica que `PageEl` é definido dentro
       * deste método, então cada render do `CriarComic` cria um TIPO de componente novo, o React
       * desmonta e remonta, e todo `useState` volta ao inicial.
       *
       * Medido em 26/09: o clique duplo no balão chamava `abrirEdicaoDeTexto` — a marca "abriu" foi
       * registrada —, e a caixa não aparecia na tela. A causa é a ordem: o clique **seleciona**, a
       * seleção muda o estado do editor, a página remonta, e o `setPopUpInfo` do item escreve num
       * componente que já não existe.
       *
       * Quando o editor passa a própria caixa por aqui, ela mora no `CriarComic` e a remontagem da
       * página não a alcança. O mesmo vale para o botão "Editar texto" do menu, que tinha o mesmo
       * defeito sempre que qualquer coisa mudava de estado entre a seleção e o clique.
       */
      caixaDoEditor?: (info?: PopUpInfo) => void;
    }
  ) {
    const page = this.pages[pageNum];
    const PageEl = () => {
      const [_forceUpdate, set_forceUpdate] = useState(false);
      function forceUpdate() {
        set_forceUpdate(!_forceUpdate);
      }

      const [popUpInfo, setPopUpInfo] = useState<undefined | PopUpInfo>(
        undefined
      );
      // A caixa que os ITENS usam: a do editor quando ela vem, senão a desta página. A diferença
      // está escrita em `caixaDoEditor`, acima, e ela decide se a caixa sobrevive ao redesenho.
      const caixaDoItem = (options?.caixaDoEditor ??
        setPopUpInfo) as Dispatch<SetStateAction<PopUpInfo | undefined>>;
      const [editingColor, setEditingColor] = useState<string | null>(null);
      const [items, setItems] = useState(page.items);
      // ══ A SELECAO NASCIA NULA, E A PAGINA REMONTA A CADA MUDANCA DE ESTADO DO EDITOR ═══════
      //
      // `PageEl` e definido AQUI DENTRO, entao cada chamada de `renderPage` cria um TIPO DE
      // COMPONENTE NOVO. Para o React, tipo novo e outro componente: ele DESMONTA o anterior e
      // monta este do zero — e todo `useState` volta ao valor inicial. Com `null` como inicial,
      // a selecao era jogada fora.
      //
      // E `renderPage` e chamado a cada render do `CriarComic`. Entao QUALQUER mudanca de estado
      // do editor desselecionava: mover camada, arrastar, redimensionar, inserir, apagar — todas
      // passam por `registrar()`, que avisa o desfazer, que muda estado la em cima.
      //
      // MEDIDO EM 13/09: selecionar um quadro e clicar em "Mover para cima" fazia o menu do item
      // SUMIR. Dava para mudar de camada exatamente uma vez.
      //
      // E o `T4.6` na letra dele — "eu faco um ajuste nele, sei qual foi, eu perco a selecao
      // dele. Nao pode ser isso nao" — e e tambem a explicacao do `T4.7`: quem aperta o botao de
      // camada e ve tudo sumir conclui que camada nao funciona. Ele disse quatro vezes que nao
      // havia controle de camadas. Havia, e ele se desligava ao ser usado.
      //
      // A selecao de verdade mora no objeto `Comic` (`this.selectedItem`), que NAO e remontado.
      // Semear o estado a partir dele faz a remontagem recuperar o que ela acabou de perder.
      //
      // O CONSERTO ESTRUTURAL seria icar `PageEl` para fora de `renderPage`, para o tipo ser
      // estavel e nao haver remontagem nenhuma. E o certo, e e um refactor com risco proprio:
      // `PageEl` fecha sobre `options`, sobre `page` e sobre `this`. Fica anotado como divida,
      // e nao disfarcado: o que esta aqui trata o sintoma no lugar exato em que ele aparece.
      const [selectedItem, setSelectedItem] = useState<DraggableItem | null>(
        this.selectedItem
      );

      const canvaRef = useRef<Stage>(null);

      useEffect(() => {
        if (options?.viewOnly) return;

        this.setItems = setItems;
        this.setSelectedItem = setSelectedItem;
        this.aoAlterar(options?.aoAlterar);
      }, []);

      // ══ O SEGUNDO SINTOMA DA REMONTAGEM: O KONVA PARAVA DE ACERTAR OS ITENS ═══════════════
      //
      // MEDIDO EM 14/09, e o achado e grave: numa tirinha de tres quadros, TROCAR DE QUADRO nao
      // funcionava. Clicar no quadro 2 com o quadro 1 selecionado DESSELECIONAVA, em vez de
      // passar a selecao. Para chegar ao segundo quadro era preciso clicar no fundo primeiro.
      //
      // E nao era o `onClick`: perguntando ao proprio Konva com `stage.getIntersection()`, o
      // ponto do quadro 2 respondia o RETANGULO BRANCO DO FUNDO. Com nada selecionado, o mesmo
      // ponto respondia o quadro. Ou seja — o grafo de acerto ficava VELHO.
      //
      // A causa e a mesma que ja custou a selecao (ver o comentario do `useState` acima):
      // `PageEl` e definido dentro de `renderPage`, entao toda mudanca de estado do editor
      // DESMONTA e MONTA a pagina. A cena era redesenhada; o canvas de ACERTO, que e outro
      // canvas, nao.
      //
      // `drawHit()` depois de cada render o reconstroi. E o remendo do remendo, e fica dito:
      // o conserto de verdade e icar `PageEl` para fora de `renderPage` — anotado como divida
      // no `useState` da selecao, com a razao de eu nao fazer isso junto com o resto.
      useEffect(() => {
        if (options?.viewOnly) return;
        canvaRef.current?.getLayers().forEach((camada) => camada.drawHit());
      });

      useEffect(() => {
        const keydownListener = (e: KeyboardEvent) => {
          if (e.code === "Delete" && !!this.selectedItem) {
            this.deleteItem(this.selectedItem);
          }
        };

        window.removeEventListener("keydown", keydownListener);
        window.addEventListener("keydown", keydownListener);

        return () => {
          window.removeEventListener("keydown", keydownListener);
        };
      }, []);

      let [scaleX, scaleY] = [1, 1];
      if (!!options?.width) {
        scaleX = options.width / page.width;
      }
      if (!!options?.height) {
        scaleY = options.height / page.height;
      }

      const handleClick = options?.onClick ?? (() => {});

      return (
        <>
          {popUpInfo && <ConfirmPopUp {...popUpInfo} />}

          <Konva.Stage
            ref={canvaRef}
            id="canva-container"
            style={
              options?.viewOnly
                ? {}
                : options?.zoom
                ? // Com zoom, o palco tem o tamanho REAL da folha escalada e quem rola e a caixa
                  // de fora. Com `height: 85%` ele voltaria a recortar o que o zoom acabou de
                  // fazer caber.
                  { overflow: "hidden" }
                : { width: "100%", height: "85%", overflow: "auto" }
            }
            width={(options?.width ?? page.width) * (options?.zoom ?? 1)}
            height={(options?.height ?? page.height) * (options?.zoom ?? 1)}
            onClick={handleClick}
            onTouchStart={(e) => this.onTouchStart(e)}
            onTouchEnd={(e) => this.onTouchEnd(e, handleClick)}
          >
            {/* A ESCALA VAI NA `Layer`, E NAO NO `Stage`. Isto NAO e preferencia.
                Medido em producao em 10/09, com a escala no `Stage`: o DESENHO saia escalado
                (a folha inteira cabia na tela, conferido por captura), mas o TESTE DE ACERTO
                continuava em coordenadas nao escaladas. Dois cliques unicos, em paginas limpas,
                em pontos escolhidos para que as duas hipoteses discordassem:

                  pagina (120,150)  — dentro do quadro 0 se a escala valer, margem se nao
                                      -> NAO selecionou
                  pagina (1200,300) — margem direita se a escala valer, quadro 0 se nao
                                      -> SELECIONOU

                As duas apontam para o mesmo lado. Com a escala no `Stage`, a crianca veria a
                folha caber na tela e pegaria o quadro errado ao clicar — pior do que a folha
                nao caber, porque parece que funciona.

                A `Layer` desenha o proprio canvas de acerto com a transformacao dela aplicada,
                entao ali o ponto do ponteiro e o pixel do acerto sao o mesmo sistema. */}
            <Konva.Layer scaleX={options?.zoom ?? 1} scaleY={options?.zoom ?? 1}>
              <Konva.Group width={page.width} height={page.height}>
                <Konva.Rect
                  width={page.width}
                  height={page.height}
                  fill="white"
                  onClick={() => {
                    this.SelectedItem(null);
                  }}
                  onTouchStart={(e) => this.onTouchStart(e)}
                  onTouchEnd={(e) =>
                    this.onTouchEnd(e, () => {
                      this.SelectedItem(null);
                    })
                  }
                  onTouchMove={(e) => {
                    this.onTouchMove(e, !this.selectedItem);
                  }}
                />
                {items.map((item) => {
                  const ItemEl = () =>
                    item.render({
                      comic: this,
                      item,
                      scaleX,
                      scaleY,
                      isSelected: item.id === selectedItem?.id,
                      pageDims: {
                        width: options?.width || page.width,
                        height: options?.height || page.height,
                      },
                      onClick: () => {
                        if (options?.viewOnly) return;

                        // ERA UM INTERRUPTOR: clicar no item JA SELECIONADO o desselecionava.
                        //
                        // Medido em 13/09 — primeiro clique seleciona (o menu do item aparece),
                        // segundo clique no MESMO ponto desseleciona (o menu some). Nenhuma
                        // ferramenta de desenho faz isso: clicar no que ja esta selecionado
                        // mantem a selecao, porque e assim que se arrasta, se ajusta e se
                        // aperta o botao seguinte.
                        //
                        // E o preco era alto: com o menu do item so existindo enquanto ha
                        // selecao, cada clique a mais levava embora os botoes de camada, de
                        // espelhar e de duplicar. E o `T4.6` na letra dele.
                        //
                        // Desselecionar continua existindo, e pelo caminho que todo mundo
                        // conhece: clicar no fundo da pagina (o `Rect` branco, logo acima).
                        this.SelectedItem(item);
                      },
                      onDragMove: (e, itemMenuRef) => {
                        const { target } = e;
                        const parent = target.getParent() as Group;
                        const minLengthInside = 5;

                        const box = target.getClientRect();
                        box.x -= parent.x();
                        box.y -= parent.y();
                        const pos = target.getPosition();
                        pos.x -= parent.x();
                        pos.y -= parent.y();

                        const offsetX = box.x - pos.x;
                        const offsetY = box.y - pos.y;
                        const newPos = { ...pos };
                        if (box.x < -(box.width - minLengthInside)) {
                          newPos.x = -offsetX - (box.width - minLengthInside);
                        }
                        if (box.y < -(box.height - minLengthInside)) {
                          newPos.y = -offsetY - (box.height - minLengthInside);
                        }
                        if (box.x + minLengthInside > parent.width()) {
                          newPos.x = parent.width() - minLengthInside - offsetX;
                        }
                        if (box.y + minLengthInside > parent.height()) {
                          newPos.y =
                            parent.height() - minLengthInside - offsetY;
                        }
                        newPos.x += parent.x();
                        newPos.y += parent.y();
                        target.setPosition(newPos);
                        if (!!itemMenuRef) {
                          let box = {
                            x: target.x(),
                            y: target.y(),
                            width: target.width(),
                            height: target.height(),
                            rotation: Utils.degreesToRadians(target.rotation()),
                          };
                          const corners = Utils.getCorners(box);
                          const menuPos = Utils.getClientRectTopMidPos(corners);
                          itemMenuRef.style.left = `${
                            menuPos.left - itemMenuRef.clientWidth / 2
                          }px`;
                          itemMenuRef.style.top = `${
                            menuPos.top - itemMenuRef.clientHeight - 10
                          }px`;
                        }
                      },
                      onDragEnd: (e) => {
                        // O retrato sai ANTES de escrever a posicao nova: neste instante o
                        // `item` ainda esta onde estava quando o arraste comecou, entao nao ha
                        // necessidade de instrumentar `onDragStart` — e de instrumentar cinco
                        // classes de item para faze-lo chegar la.
                        this.registrar();
                        const target = e.target;
                        [item.x, item.y] = [target.x(), target.y()];
                        // forceUpdate();
                      },
                      boundBoxFunc: (oldBox, newBox, itemMenuRef) => {
                        if (
                          Utils.isInsideCanva(
                            newBox.x,
                            newBox.y,
                            newBox.width,
                            newBox.height,
                            newBox.rotation,
                            page.width,
                            page.height
                          )
                        ) {
                          if (!!itemMenuRef) {
                            const corners = Utils.getCorners(newBox);
                            const menuPos =
                              Utils.getClientRectTopMidPos(corners);
                            itemMenuRef.style.left = `${
                              menuPos.left - itemMenuRef.clientWidth / 2
                            }px`;
                            itemMenuRef.style.top = `${
                              menuPos.top - itemMenuRef.clientHeight - 10
                            }px`;
                          }

                          return newBox;
                        }

                        return oldBox;
                      },
                      onTransformEnd: (ev) => {
                        // Mesmo motivo do `onDragEnd` acima.
                        const { target } = ev;
                        // T20 · O SEGUNDO FIM, SEM CAIXA. Medido no ar em 12/10 (pilha: `destroy` →
                        // `_removeEvents` → `_fire` → aqui): o `forceUpdate()` do fim legítimo
                        // remonta o item, o Transformer velho é destruído AINDA no meio do gesto e
                        // dispara `transformend` de novo, já sem nó. Ler a escala de `undefined`
                        // dentro da montagem derrubava a tela ("Alguma coisa deu errado").
                        //
                        // E aqui não se redesenha nem se lê a caixa velha: a medida já foi
                        // guardada pelo primeiro fim, e reler a caixa (com escala 1) desfaria o
                        // redimensionamento que a pessoa acabou de fazer.
                        if (!target) return;
                        this.registrar();
                        const [scaleX, scaleY] = [
                          target.scaleX(),
                          target.scaleY(),
                        ];
                        [item.x, item.y] = [target.x(), target.y()];
                        // 'transformer' muda apenas a escala e não o comprimento e altura em si
                        // Multiplicando o comprimento pela escala obtem-se as novas dimensões
                        [item.width, item.height] = [
                          target.width() * scaleX,
                          target.height() * scaleY,
                        ];
                        item.rotation = target.rotation();

                        // reseta a escala para 1
                        target.scale({ x: 1, y: 1 });
                        forceUpdate();
                      },
                      setPopUpInfo: caixaDoItem,
                      EditingColor: Utils.stateToGetSet(
                        editingColor,
                        setEditingColor
                      ),
                    });

                  return <ItemEl key={item.id} />;
                })}
              </Konva.Group>
            </Konva.Layer>
          </Konva.Stage>
        </>
      );
    };
    return <PageEl key={pageNum} />;
  }

  async exportToPdf() {
    const pages = this.pages.map((_, i) =>
      this.renderPage(i, { viewOnly: true })
    );
    const hiddenComicCanva = document.createElement("canva");
    // hiddenComicCanva.id = "hidden-comic-container";
    hiddenComicCanva.style.display = "none";
    document.body.appendChild(hiddenComicCanva);

    // Renderizar o JSX dentro da div usando React
    const root = ReactDOM.createRoot(hiddenComicCanva);
    root.render(pages);

    while (hiddenComicCanva.children.length !== this.pages.length) {
      await Utils.sleep(10);
    }

    const pdf = new jsPDF();
    pdf.deletePage(1);
    for (var i = 0; i < hiddenComicCanva.children.length; i++) {
      const child = hiddenComicCanva.children[i];
      const childCanva = child.querySelector("canvas");
      if (!!childCanva) {
        const dataURL = childCanva.toDataURL();
        const { width, height } = childCanva;

        pdf.addPage([width, height], height > width ? "p" : "l");
        pdf.addImage(dataURL, "PNG", 0, 0, width, height);
      }
    }

    // pdf.save(`${this.name || "comic"}.pdf`);
    const blob = pdf.output("blob");
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${this.name || "comic"}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(hiddenComicCanva);
    root.unmount();
  }

  toObj() {
    return {
      name: this.name,
      pages: Utils.arrToDict(this.pages.map((page) => page.toObj())),
    };
  }

  isSaved() {
    return !!this.id;
  }

  async save(userId: string, comicName = this.name) {
    this.name = comicName;
    // Zera ANTES de escrever, e nao depois: se a escrita falhar, o `catch` de quem chama avisa a
    // pessoa, e ela tenta de novo. Zerar depois deixaria uma falha de rede com o contador em pe
    // e o aviso aparecendo para sempre.
    this.alteracoesDesdeOSave = 0;
    if (!this.name) {
      throw new Error("Nome inválido");
    }

    if (!this.id) {
      const docRef = await Firebase.pushDocument(
        `users/${userId}/comics`,
        this.toObj()
      );
      this.id = docRef.id;
    } else {
      await Firebase.setDocument(
        `users/${userId}/comics`,
        this.id,
        this.toObj()
      );
    }
  }
  /**
   * APAGAR O QUADRINHO — e a copia PUBLICADA dele, se houver.
   *
   * Isto ganhou a segunda metade no PL-T2.7, e ela e a saida que a duvida D2 decidiu existir.
   *
   * O T2.60 diz que quem finalizou "nao tem mais como efetivamente editar aquele quadrinho
   * depois, MAS voce pode fazer deletar aquele quadrinho e subir um novo". Apagar so o original
   * deixaria a ficha publicada de pe na biblioteca — o quadrinho continuaria la, legivel, e a
   * pessoa nao teria mais como mexer nele por lugar nenhum. Seria o pior dos dois mundos: o
   * trabalho apagado da conta dela e vivo na prateleira.
   *
   * A ORDEM E DELIBERADA: a copia publicada primeiro, o original depois. Se a segunda falhar, a
   * pessoa fica com o original e sem a publicacao — que e o estado de quem despublicou, e da para
   * tentar de novo. Na ordem inversa, uma falha deixaria a publicacao orfa e sem nada que a
   * apagasse.
   *
   * E a falha ao apagar a publicacao NAO interrompe: pode nao haver publicacao nenhuma (o caso
   * comum), e nesse caso o Firestore devolve negado ou nada. Apagar o que a pessoa pediu para
   * apagar vale mais do que a limpeza perfeita da prateleira.
   */
  async delete(userId: string) {
    if (!this.id) {
      throw new Error("Quadrinho não salvo");
    }

    try {
      await Firebase.deleteDocument("biblioteca", this.id);
    } catch (e) {
      console.warn(
        "[comic] nao apaguei a copia publicada (pode nao existir):",
        (e as Error)?.message
      );
    }

    await Firebase.deleteDocument(`users/${userId}/comics`, this.id);
  }
}
